<template>
  <span
    class="font-medium"
    :class="{
      'text-placeholder_subtle': !dueDate,
      'text-secondary': !overdue && dueDate,
      'text-error-primary': overdue && dueDate,
      'text-style-xs': size === 'sm',
      'text-style-sm': size === 'md',
      'text-style-base': size === 'lg',
    }"
  >
    {{ label }}
  </span>
</template>
<script setup>
import { computed } from "vue";
import { sizes } from ".";
import { useI18n } from "vue-i18n";
import { formatDate } from "@/Utils/date";

const { t } = useI18n();
const props = defineProps({
  dueDate: {
    type: [String, Date, Number, null],
    required: false,
  },
  isOverdue: { type: Boolean, required: false },
  size: {
    type: String,
    validator: (value) => sizes.includes(value),
    default: "sm",
  },
  placeholder: { type: String, required: false },
});

const label = computed(() => {
  if (!props.dueDate) {
    return props.placeholder || t("components.filters.due_date.label");
  }
  return formatDate(props.dueDate);
});

/**
 * Support for both scenarios, manual isOverdue prop and automatic due date check
 */
const overdue = computed(() => {
  if (!props.dueDate) {
    return false;
  }

  return props.isOverdue !== undefined
    ? props.isOverdue
    : Date.now() > new Date(props.dueDate).getTime();
});
</script>
